import { messaging } from "./firebase";
import AsyncLocalStorage from '@createnextapp/async-local-storage';

const VAPID_KEY = "BOgLGMdRmAzOWV2Xs7qC0LHoCZ71R5hc_C6jR_6ZI_n2gxyRLWAeknHTlXydsx_tCXlJSb3Jo7m-jbWS_1w0OS0";

export const requestPermission = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
            console.warn("Notification permission denied");
            return null;
        }

        // Always fetch fresh token from Firebase — it returns cached token if still valid
        const token = await messaging.getToken({ vapidKey: VAPID_KEY });
        if (token) {
            localStorage.setItem('device_token', token);
            await AsyncLocalStorage.setItem('device_token', token);
            registerMessageListener();
            return token;
        } else {
            console.warn("No FCM token — check VAPID key or service worker");
            return null;
        }
    } catch (err) {
        console.error("FCM Error:", err);
        return null;
    }
};

// Prevent duplicate onMessage listeners
let messageListenerRegistered = false;
let notificationChannel = null;
const NOTIFICATION_LOCK_KEY = 'fcm_notification_lock';
const LOCK_DURATION = 1000;

export const registerMessageListener = () => {
    if (messageListenerRegistered) return () => { };
    messageListenerRegistered = true;

    // Create BroadcastChannel for cross-tab communication
    notificationChannel = new BroadcastChannel('fcm-notifications');
    let isLocked = false;

    // Listen for lock signals from other tabs
    notificationChannel.onmessage = (event) => {
        if (event.data.type === 'notification-lock') {
            isLocked = true;
            setTimeout(() => { isLocked = false; }, LOCK_DURATION);
        }
    };

    const unsubscribe = messaging.onMessage((payload) => {
        console.log("Foreground notification received:", payload);

        // Check if locked by another tab
        if (isLocked) {
            console.log("Notification locked by another tab");
            return;
        }

        // Try to acquire lock using localStorage
        const now = Date.now();
        const lockData = localStorage.getItem(NOTIFICATION_LOCK_KEY);

        if (lockData) {
            const lockTime = parseInt(lockData);
            if (now - lockTime < LOCK_DURATION) {
                console.log("Notification locked by localStorage");
                return;
            }
        }

        // Acquire lock
        localStorage.setItem(NOTIFICATION_LOCK_KEY, now.toString());
        isLocked = true;

        // Broadcast lock to other tabs immediately
        notificationChannel.postMessage({
            type: 'notification-lock',
            timestamp: now
        });

        if (Notification.permission === 'granted') {
            // Show notification
            new Notification(payload.notification?.title || 'New Notification', {
                body: payload.notification?.body || '',
                icon: '/favicon.ico',
                tag: 'fcm-notification',
                requireInteraction: false
            });
        }

        // Release lock after duration
        setTimeout(() => {
            isLocked = false;
            const currentLock = localStorage.getItem(NOTIFICATION_LOCK_KEY);
            if (currentLock === now.toString()) {
                localStorage.removeItem(NOTIFICATION_LOCK_KEY);
            }
        }, LOCK_DURATION);
    });

    return () => {
        unsubscribe();
        if (notificationChannel) {
            notificationChannel.close();
            notificationChannel = null;
        }
        messageListenerRegistered = false;
    };
};
